import { MetaDefinition } from '@angular/platform-browser';

export const Metas: MetaDefinition[] = [
  {
    name: 'robots',
    content: 'index,follow',
  },
  {
    property: 'og:type',
    content: 'article',
  },
];
